import { useEffect, useState } from 'react';
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Column } from '../../../Components/Tables/Table';
import { prepareSearchColumns } from '../../../Utility/Utility';
import InventoryList from '../common/list/List';
import { InventoryOverviewProps } from '../common/model/inventory-common.model';
import useEventSystem from "../../../events/useEventSystem";
import useClientStore from '../../../store/client/useClientStore';

export default function InventoryOverview() {
  const pageName = "Inventory Overview";
  const addUrl=""
  const listUrl=""
  const gridUrl=""
  const statusUpdateEndpoint = "items"
  const ListingEndpoint="items/query";
  const [clientId, setClientId] = useState<any>(null);
  const navigation=useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const { emit } = useEventSystem();
  const { getSelectedClient } = useClientStore();
  const [confirmModalData, setConfirmModalData] = useState({
    customer_id:0,
    showconfModal: false,
    message:''
  });
  useEffect(() => {

    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedClient]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true
    }));
  };
  const handleQtyExpCol = (row: any) => {
    navigation(`/inventory/overview/overview-qty-exp/qty:${row.invQtyOnExpected}/item-code:${row.invItemCode}`);
  }

  useEffect(() => {
    emit('show_warehouse_warning', false);
  }, [])

  const columns: Column[] = [
    {
      name: "Item Code",
      column_name:"item.code",
      selector: (row: InventoryOverviewProps) => (
        <span onClick={() => getDetails(row)} className="cursor-pointer text-primary ">
          {row.code}
        </span>
      ),
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Item Name",
      column_name:"item.name",
      selector: (row: InventoryOverviewProps) => ( row.name),
      enableSorting: true, // Enable sorting for this column
    },
    {
      name: "Qty On Hand",
      selector: (row: InventoryOverviewProps) => row.qty_on_hand,
    },
    {
      name: "Qty Reserved",
      selector: (row: InventoryOverviewProps) => row.qty_reserved,
    },
    {
      name: "Qty Available Now ",
      selector: (row: InventoryOverviewProps) => row.qty_on_hand - row.qty_reserved,
    },
    {
      name: "Qty Expected",
      selector: (row: InventoryOverviewProps) =>  
      {
        return row.qty_expected > 0 ? (
          <span className='cursor-pointer text-decoration-underline' onClick={() => handleQtyExpCol(row)} >{row.qty_expected}</span>
        ) : (
          <span>{row.qty_expected}</span>
        )
      },
    },
    {
      name: "Qty Available Future",
      selector: (row: InventoryOverviewProps) => row.qty_on_hand - row.qty_reserved + row.qty_expected,
    },
    {
      name: <></>,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => getDetails(row)}
            >
              View
            </li>
          </ul>
        </>
      ),
    },
  ];
  const db_columns= [
    {
        "data": "item.id"
    },
    {
        "data": "item.code"
    },
    {
        "data": "item.name"
    },
    {
        "data": "qty_on_hand"
    },
    {
        "data": "qty_reserved"
    },
    {
        "data": "qty_expected"
    }
];
  const exclude_columns:any = ["qty_expected","qty_reserved","qty_on_hand"];
  const search_columns = exclude_columns?prepareSearchColumns(db_columns, exclude_columns):[];
  const sorting_order=[
    {
      column: "item.id",
      dir: "desc",
    },
  ];
  const getDetails = (item: any) => {
    navigation(`/inventory/overview/details/${item.id}`);
  };

  return (
   <InventoryList 
    pageName={pageName}
    columns={columns}
    addUrl={addUrl}
    listUrl={listUrl}
    gridUrl={gridUrl}
    search_columns={search_columns}
    db_columns={db_columns}
    data={data}
    listEndpoint={ListingEndpoint}
    sorting_order={sorting_order}
    clientId={clientId}
    />
)

}
